<template>
  <div class="amap-page-container">
    <el-amap
      vid="amapTrajectory"
      :zoom="zoom"
      :center="center"
      class="amap-Order"
      show-dir="true"
    >
      <el-amap-bezier-curve
        v-for="(line,index) in lines"
        :key="index"
        :events="line.events"
        :path="line.path"
        :stroke-color="line.strokeColor"
        :stroke-style="line.strokeStyle"
        :stroke-opacity="line.strokeOpacity"
      />
      <el-amap-marker
        vid="component-marker"
        :position="componentMarker.starPosition"
        :icon="componentMarker.starIcon"
      />
      <el-amap-marker
        vid="component-marker"
        :position="componentMarker.endPosition"
        :icon="componentMarker.endIcon"
      />
    </el-amap>
  </div>
</template>
<script>
import Vue from 'vue'
import { ajax } from '@/api/ctms'
import startImg from '@/assets/tongcheng/map/qi.png'
import endImg from '@/assets/tongcheng/map/zhong.png'
import VueAMap from 'vue-amap'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geocoder',
    'AMap.Geolocation'
  ],
  v: '1.4.4',
  uiVersion: '1.0'
})
export default {
  name: 'TrajectoryMap',
  data() {
    return {
      isUnload: '',
      loadingLatitude: '29.866002',
      loadingLongitude: '121.630925',
      deliveryLatitude: '29.866002',
      deliveryLongitude: '121.630925',
      zoom: 15,
      zoomEnable: false,
      center: [121.630925, 29.866002],
      mark: { position: [], data: {}},
      lines: [
        {
          path: [
            [121.630925, 29.866002], // 起点
            // [113.8622, 36.962267, 114.477434, 38.077584],
            [121.630925, 29.866002] // 终点
          ],
          strokeDasharray: [10, 10],
          strokeColor: '#FF0000', // 线颜色
          strokeOpacity: 0.8, // 线透明度
          strokeWeight: 3, // 线宽
          strokeStyle: 'solid', // 线样式
          events: {}
        }
      ],
      componentMarker: {
        starPosition: [121.630925, 29.866002], // 起点坐标
        starIcon: startImg,
        endPosition: [121.630925, 29.866002], // 终点
        endIcon: endImg
      },
      form: {}
    }
  },
  created() {
    this.form.ordercode = this.$route.query.orderCode
  },
  mounted() {
    this.getInfo()
    const that = this
    window.onresize = function() {
      that.getInfo()
    }
  },
  methods: {
    // 获取页面信息获取详情信息
    getInfo() {
      // 高德猎鹰运输轨迹
      ajax('/ntocc-ctms-api/ctmsOrderDetail/getOrderTraceAndlye', 'GET', this.form)
        .then(data => {
          var tranks = data.trank
          if (tranks != null && tranks.length > 0) {
            const trackPath = []
            this.center = [Number(tranks[0].lon), Number(tranks[0].lat)]
            this.componentMarker.starPosition = [Number(tranks[0].lon), Number(tranks[0].lat)]
            this.componentMarker.endPosition = [Number(tranks[tranks.length - 1].lon), Number(tranks[tranks.length - 1].lat)]
            tranks.forEach((item, index) => {
              trackPath.push([item.lon, item.lat])
            })
            this.lines[0].path = trackPath
          } else {
            this.center = [Number(this.loadingLongitude), Number(this.loadingLatitude)]
            this.componentMarker.starPosition = [Number(this.loadingLongitude), Number(this.loadingLatitude)]
            this.componentMarker.endPosition = [Number(this.deliveryLongitude), Number(this.deliveryLatitude)]
            this.lines[0].path = [[Number(this.loadingLongitude), Number(this.loadingLatitude)], [Number(this.deliveryLongitude), Number(this.deliveryLatitude)]]
          }
        })
        .catch(error => {
          // console.log(error);
        })
    }

  }
}
</script>
<style lang="scss" scoped>

  .amap-page-container {
    height: 100%;
  }

  .amap-Order {
    height: 100%;

  }

  .amap-page-container {
    width: 100% !important;
    height: 100% !important;
  }
</style>
<style>
  .amap-Order .amap-icon img {
    width: 30px;
    height: 30px;
    position: absolute;
    left: -5px !important;
    top: 2px !important;
  }
</style>
